import React from 'react';
import { OnboardingStep } from '../onboarding.types';
import { OnboardingClasses } from '../onboarding.enums';

export const BOOKING_CREATION_TOUR: OnboardingStep[] = [
    {
        className: OnboardingClasses.CREATE_BOOKING_BUTTON,
        placement: 'bottom',
        title: 'Create Booking',
        borderRadius: 18,
        content: (
            <>
                Let&#39;s create the first booking for the product we just
                created.
            </>
        ),
        nextOnTargetClick: true,
    },
    {
        className: OnboardingClasses.CREATE_BOOKING_MODAL,
        placement: 'right',
        title: 'Create Booking Modal',
        borderRadius: 10,
        waitForTarget: true,
        content: (
            <>
                Enter the dates where we can create the first booking and the
                number of people who will participate in the activity.
            </>
        ),
    },
    {
        className: OnboardingClasses.CHECK_AVAILABILITY_BUTTON,
        placement: 'bottom',
        title: 'Check Availability',
        borderRadius: 10,
        content: <>If all has been filled, press Check availability.</>,
        nextOnTargetClick: true,
    },
    {
        className: OnboardingClasses.AVAILABILITY_CALENDAR,
        placement: 'center',
        title: 'Availability Calendar',
        content: (
            <>
                This is Travelity&#39;s availability calendar, where you can
                check for the availability of any or all of your products.
            </>
        ),
        waitForTarget: true,
    },
    {
        className: OnboardingClasses.SEE_ALL_PRODUCTS_LINK,
        placement: 'right',
        title: 'See All Products',
        borderRadius: 10,
        content: <>Click on the See All Products to see the expanded view.</>,
        nextOnTargetClick: true,
    },
    {
        className: OnboardingClasses.EXPANDED_VIEW,
        placement: 'right',
        title: 'Expanded View',
        borderRadius: 10,
        waitForTarget: true,
        content: (
            <>
                All the products available on this day will be visible here with
                their respective start times.
            </>
        ),
    },
    {
        className: OnboardingClasses.FIRST_TIME_SLOT,
        placement: 'right',
        title: 'Select Start Time',
        borderRadius: 10,
        content: (
            <>Tap the starting time for which you want to make a booking.</>
        ),
        nextOnTargetClick: true,
    },
    {
        className: OnboardingClasses.BOOKING_PREVIEW,
        placement: 'right',
        title: 'Booking Preview',
        borderRadius: 10,
        waitForTarget: true,
        content: (
            <>
                Select any of the start times you need. Use arrow to slide pages
                of the start times. Fill in the info requested in the form.
            </>
        ),
    },
    {
        className: OnboardingClasses.SAVE_AS_DRAFT_BUTTON,
        placement: 'right',
        title: 'Save as Draft',
        borderRadius: 10,
        content: (
            <>
                Saving the booking as draft will create a draft booking which
                doesn&#39;t block the timeslot availability. This is for the
                cases when your customers are only inquiring for information on
                prices, and not committing to buy the services.
            </>
        ),
    },
    {
        className: OnboardingClasses.CONFIRM_BUTTON,
        placement: 'right',
        title: 'Confirm Booking',
        borderRadius: 10,
        content: (
            <>
                Confirming the booking will result in considering the booking in
                your availability calendar. This means that based on your
                product&#39;s and user settings the respective timeslot may not
                be available for other bookings. Press either of the buttons to
                proceed.
            </>
        ),
        nextOnTargetClick: true,
    },
    {
        className: OnboardingClasses.ORDER_MENU,
        placement: 'bottom',
        title: 'Order Menu',
        borderRadius: 10,
        waitForTarget: true,
        content: (
            <>
                Your booking triggered creation of an order for the customer.
                Think of the order as the shopping cart. Tap on your order and
                explore.
            </>
        ),
    },
    {
        className: OnboardingClasses.DAILY_VIEW_MENU,
        placement: 'right',
        title: 'Daily View',
        borderRadius: 10,
        content: (
            <>
                If you confirmed your booking, then an event has been created to
                occupy the calendar. All events can be tracked from the Daily
                view.
            </>
        ),
    },
];
